import { useContext } from 'react';
import { ConfigContext } from 'contexts/ConfigContext';

// ==============================|| CONFIG HOOK  ||============================== //

const useConfig = () => useContext(ConfigContext);

export default useConfig;
